import React from "react";
import { Box, Chip } from "@mui/material";
import logo from '../../assets/images/stream.png';
import BlogPostsList from "containers/pages/CANblog/components/BlogPostsList/BlogPostsList";

function BlogListPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "95vh",
      }}
    >
      {/* Main content area */}
      <Box sx={{ flex: 1, p: { xs: 0, sm: 4 } }}>
        <BlogPostsList />
      </Box>

      {/* Footer with Chip */}
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <Chip
          label="Powered by Stream Data Systems"
          variant="outlined"
          icon={
            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ width: 20, height: 20 }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default BlogListPage;
